<template>
  <div>
    <div class="simple-box">
      <div class="simple-box-big-title">{{bigTitle}}</div>
      <div class="simple-box-big-number">{{bigNumberString}}</div>
      <div class="simple-box-sub-info">
        <span class="sub-cal ">{{subTitle+(subPersent?subPersent:'')}}</span>
        <span class="iconfont" :class='{
          "icon-statistics-up":subNumber > 0,
          "icon-statistics-down":subNumber <= 0,
          "icon-hide":typeof subPersent !== "string"
        }'></span>
        <slot name='tips'>
          <span class="simple-box-tips" :class='{
            "tips-hide":typeof tips === "undefined"
          }'>{{tips}}</span>
        </slot>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    props: {
      bigTitle: {
        type: String,
        default: '标题'
      },
      bigNumberString: {
        type: [String, Number],
        default: '123456'
      },
      subTitle: {
        type: String
      },
      subNumber: {
        type: Number
      },
      tips: {
        type: String
      }
    },
    computed: {
      subPersent() {
        if (this.subNumber !== 0 && typeof this.subNumber === 'number') {
          return Number(this.subNumber * 100).toFixed(2) + '%';
        } else if (this.subNumber === 0) {
          return '-0%'
        } else {
          return null
        }
      }
    }
  }

</script>
<style src='../../../../../assets/icon/iconfont.css'></style>
<style scoped>
  .simple-box {
    height: 86px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .simple-box-big-title,
  .simple-box-sub-info,
  .simple-box-sub-info span {
    font-family: MicrosoftYaHei;
    font-size: 14px;
    line-height: 14px;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 1px;
    color: #666666;
  }

  .simple-box-big-number {
    font-family: MicrosoftYaHei-Bold;
    font-size: 22px;
    line-height: 22px;
    font-weight: bold;
    font-stretch: normal;
    letter-spacing: 1px;
    color: #666666;
    margin: 20px 0;
  }

  .iconfont {
    color: #2783f2 !important;
  }

  .simple-box-tips {
    margin-left: 40px;
  }

  .icon-hide {
    opacity: 0;
  }

  .tips-hide {
    display: none;
  }

</style>
